import * as React from 'react';
import type { SVGProps } from 'react';

const SvgGreyCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#ABABAB"
      fillRule="evenodd"
      d="M13.076 6.574 7.771 12.04l-1.445-1.724a.86.86 0 0 0-1.249-.087.95.95 0 0 0-.083 1.303l2.065 2.462a.87.87 0 0 0 .633.314h.033a.867.867 0 0 0 .622-.265l5.973-6.154a.952.952 0 0 0 .008-1.306.86.86 0 0 0-1.252-.008M9.586 20C4.3 20 0 15.514 0 10S4.3 0 9.587 0c5.286 0 9.587 4.486 9.587 10s-4.301 10-9.587 10Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGreyCheckIcon;
